//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {formateTimeStamp } from '@/assets/js/tool';
export default {
    data: () => ({
        id:'',
        states:1,
        infos:'', //投标详情
        info:'', //项目详情
        hisInfo:[], //历史投标记录
        times:'',
        offline:''
    }),
    methods: {
       //切换投标详情和项目详情
       changeStates(index){
            this.states= index
       },
        //投标详情
        bidInfo(){
            this.$get('/tra/project/bid/detail?projectId='+this.$route.query.id,function(res){
              if(res.code==200){
                  this.infos = res.data;
                  this.bidHisInfo(res.data.id)
              }
            })
        },
        getOfflineInfo(){
          let params = { traProjectId: this.$route.query.id }
          this.$get('/pay/order/offlineAccountsDetail',params,function(res) {
              if(res.code==200){
                  this.offline= res.data
              }
            });
        },
        // 历史投标记录
        bidHisInfo(id){
            this.$get('/tra/project/bid/his/list?traProjectBidId='+id,function(res){
                if (res.code == 200) {
                    this.hisInfo =res.data;
                }
            })
        },

        // 项目详情
        projectDetail(){
            this.$get('/tra/project/detail?id='+this.$route.query.id,function(res){
                if(res.code==200){
                  this.info = res.data;
                  var d = new Date();
                  var bidEndTime = new Date(res.data.bidEndTime).getTime() /1000;  //结束时间
                  var times = d.getTime() /1000; //当前时间
                  var residueTime = bidEndTime - times;
                  var TimeDown = setInterval(() => {
                      if (residueTime > 0) {
                        residueTime--;
                        const newTime = formateTimeStamp(residueTime);
                        const str = `${newTime.day}天${newTime.hour}时${newTime.min}分${newTime.seconds}秒`
                        this.times = str;
                      } else {
                        this.times = '投标已结束'
                        clearInterval(TimeDown);
                      }
                  }, 1000)
                }
            })
        },

        // 项目进程
        progress(type){
            if(type==1){  //审核类
                this.$router.push({
                    path:'/facilitator/underProMeetInfo?id='+this.id
                })
            }
            if(type==2){ //编制类
                this.$message.info('暂未开放编制类')
                return
                // this.$router.push({
                //     path:'/facilitator/underProInfo?id='+this.id
                // })
            }
        },

        // 修改报价
      baojia(){
        var userInfo= getSession('user');
        if(userInfo.currentUserType==2){
          if(userInfo.providerAuthStatus==2){
            this.$message.info('认证审核中,请稍后尝试!');
            return;
          }
          if(userInfo.providerAuthStatus==0||userInfo.providerAuthStatus==3){
            this.$message.info('请认证完毕，再投标!');
            this.$router.push({
              path:'/facilitator/completeInfo'
            })
            return;
          }
        }
        this.$prompt('请根据发包商提供的项目信息，输入您的报价，若发包商同意，则形成项目单！', '报价(元)', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^\d+$|^\d+[.]?\d+$/,
            inputErrorMessage: '只能输入数字'
          }).then(({ value }) => {
            //点击确定执行方法
            this.$post('/tra/project/bid',{
              finalOffer:value,
              isAttend:false,
              isChose:this.infos.isChose,
              isExit:this.infos.isExit,
              isInvited:this.infos.isInvited,
              isOffer:false,
              isSign:false,
              traProjectId:this.$route.query.id,
              userId:getSession('user').id
            },function(res){
              if(res.code==200){
                this.$message.success('报价成功!');
                this.bidInfo();
                this.getDetailData();
              }
            },true)
          }).catch(() => {

          });
      },

      // 取消投标
      cancelBj(){
        this.$confirm('确定要取消投标吗?','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=>{
          this.$put('/tra/project/bid/cancelCalibration?id='+this.infos.id,'',function(res){
              if(res.code==200){
                this.$message.success('取消成功!');
                this.$router.back(-1)
              }
          },true)

        })
      }


    },
    mounted() {
       this.id = this.$route.query.id
       this.bidInfo();
       this.getOfflineInfo()
       this.projectDetail();
       if(!this.$route.query.id){
            this.$router.go(-1)
        }
    }
}
